export const MOB_DEFINITIONS = {
    grunt: {
        type: "grunt",
        displayName: "Grunt",
        baseStats: {
            maxHp: 40,
            speed: 2.0,
            armor: 0,
            isFlying: false,
            bounty: 5,
            damageToBase: 1,
        },
        sendCost: 30,
        sendIncomeBonus: 2,
    },
    runner: {
        type: "runner",
        displayName: "Runner",
        baseStats: {
            maxHp: 25,
            speed: 3.5,
            armor: 0,
            isFlying: false,
            bounty: 4,
            damageToBase: 1,
        },
        sendCost: 40,
        sendIncomeBonus: 2,
    },
    tank: {
        type: "tank",
        displayName: "Tank",
        baseStats: {
            maxHp: 200,
            speed: 1.2,
            armor: 5,
            isFlying: false,
            bounty: 18,
            damageToBase: 3,
        },
        sendCost: 120,
        sendIncomeBonus: 6,
    },
    flyer: {
        type: "flyer",
        displayName: "Flyer",
        baseStats: {
            maxHp: 60,
            speed: 2.5,
            armor: 0,
            isFlying: true,
            bounty: 10,
            damageToBase: 2,
        },
        sendCost: 80,
        sendIncomeBonus: 4,
    },
    armored: {
        type: "armored",
        displayName: "Armored",
        baseStats: {
            maxHp: 100,
            speed: 1.8,
            armor: 10,
            isFlying: false,
            bounty: 12,
            damageToBase: 2,
        },
        sendCost: 90,
        sendIncomeBonus: 4,
    },
    swarm: {
        type: "swarm",
        displayName: "Swarm",
        baseStats: {
            maxHp: 15,
            speed: 2.2,
            armor: 0,
            isFlying: false,
            bounty: 2,
            damageToBase: 1,
        },
        sendCost: 50,
        sendIncomeBonus: 3,
    },
    boss: {
        type: "boss",
        displayName: "Boss",
        baseStats: {
            maxHp: 2000,
            speed: 1.0,
            armor: 20,
            isFlying: false,
            bounty: 200,
            damageToBase: 20,
        },
        sendCost: null,
        sendIncomeBonus: 0,
    },
};
export function getMobDefinition(type) {
    return MOB_DEFINITIONS[type];
}
export function scaleMobStats(base, waveIndex, tutorialLevel) {
    const isTutorial = tutorialLevel != null;
    const hpScale = 1 + waveIndex * (isTutorial ? 0.08 : 0.18);
    const armorScale = 1 + waveIndex * (isTutorial ? 0.02 : 0.05);
    return {
        ...base,
        maxHp: Math.round(base.maxHp * hpScale),
        armor: Math.round(base.armor * armorScale),
        bounty: Math.round(base.bounty * (1 + waveIndex * 0.05)),
    };
}
//# sourceMappingURL=mobs.js.map